import { apiFetch, type RequestAuth } from './client';

/**
 * One row on the read-only Installations tab. Inaccessible rows have null
 * instanceName/organization and a masked trackerId (`***xx`); `accessible`
 * flags which.
 */
export interface AppInstallationItem {
  instanceName: string | null;
  organization: string | null;
  /** shard id the install was fetched from, e.g. "us" / "eu" / "au". */
  region: string;
  /** install created-at timestamp (ISO). */
  installedAt: string;
  version: string;
  /** install last-updated timestamp (ISO). */
  lastUpdated: string;
  /** full when accessible, `***` + last 2 chars when inaccessible. */
  trackerId: string;
  accessible: boolean;
}

/** rivendell `GET /dev-portal/apps/{appId}/installations`. */
export interface AppInstallationsResponse {
  items: AppInstallationItem[];
  degradedShards: string[];
}

export function getAppInstallations(
  auth: RequestAuth,
  appId: string,
): Promise<AppInstallationsResponse> {
  return apiFetch<AppInstallationsResponse>(
    `/dev-portal/apps/${encodeURIComponent(appId)}/installations`,
    auth,
  );
}
